<div class="tout-root">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon aria-hidden="true" class="material-symbols-outlined">{{ titleIcon }}</mat-icon>
        {{ title }}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <ng-content></ng-content>
    </mat-card-content>
    <mat-card-actions align="end">
      <a matButton="filled" [routerLink]="this.link">
        <mat-icon aria-hidden="true" class="material-symbols-outlined">{{ titleIcon }}</mat-icon>
        <span class="link-text">{{ this.linkText }}</span>
      </a>
    </mat-card-actions>
  </mat-card>
</div>
